export const isSmallScreen = '(max-width: 768px)'
export const isTabletScreen = '(max-width: 1024px)'

export const DESKTOP_BREAKPOINT = 1156
